<template lang="pug" src="./justifications.pug"></template>

<script>
import moment from 'moment'
import language from '../../../../build/language/index'
import { maskThousand } from '../../../utils/numberMasker.js'

moment.locale(language.getDatePickerLanguage())

export default {
  name: 'Justifications',

  data () {
    return {
      sumAmount: 0.00,
      columns: ['motivoOcorrencia', 'comentario', 'valor', 'acoes'],
      options: {
        columnsClasses: {'motivoOcorrencia': 'col-md-4', 'comentario': 'col-md-5', 'valor': 'col-md-2 align-right', 'acoes': 'col-md-1'},
        headings: {
          motivoOcorrencia: this.$t('conciliacaoManual.labels.motivoOcorrencia'),
          comentario: this.$t('conciliacaoManual.labels.comentario'),
          valor: this.$t('conciliacaoManual.labels.valor'),
          acoes: ''
        },
        sortIcon: {
          is: ''
        },
        templates: {
          motivoOcorrencia: (h, row) => {
            return row && row.motivoOcorrencia ? row.motivoOcorrencia : '-'
          },
          comentario: (h, row) => {
            return row && row.comentario ? row.comentario : '-'
          },
          valor: (h, row) => {
            return maskThousand(row.valor)
          }
        },
        filterable: false,
        perPage: 9999,
        perPageValues: [],
        texts: {
          count: '',
          noResults: this.$t('conciliacaoManual.erro.nenhumLancamentoInterno')
        },
        sortable: ['motivoOcorrencia', 'comentario', 'valor'],
        pagination: {},
        customSorting: {
        }
      },
      justifications: []
    }
  },

  computed: {
    arrayJustify () {
      return this.$store.getters.arrayJustify
    }
  },

  watch: {
    arrayJustify () {
      this.justifications = this.$store.getters.arrayJustify
    }
  },

  methods: {
    removeJustify (justify) {
      // Remover da lista e do vuex
      this.$store.dispatch('removeJustify', justify)
        .then(() => {
          // Remonta a respectiva grid, para evitar problemas quando as entradas estão ordenadas
          // window.Grids[0].Reload()
        }).catch((error) => {
          this.$root.$refs.notification.error(error)
        })
    }
  }
}
</script>

<style>
.VueTables__table {
  margin-bottom: 1px!important;
}

.entry-table {
  max-height: 237px;
  overflow-x: hidden;
  overflow-y: auto;
  max-width: 98%;
}

.manage-value {
  text-align: center;
  font-weight: bold !important;
  font-family: 'Inter', sans-serif !important;
  font-size: 3vh !important;
  text-transform: initial !important;;
}

.manage-date {
  text-align: center;
  font-weight: bold !important;
  font-family: 'Inter', sans-serif !important;
  font-size: 2vh !important;
  text-transform: initial !important;;
}

td.align-right {
  text-align: right;
}

</style>



// WEBPACK FOOTER //
// Justifications.vue?2fff8013